import React from "react";
import '../../styles/common/header/_subHeader.css';
import { renderImg } from "../common/icons/img";
import { BE, CBT, CT, FU, HOME, PT, t } from "../../translations/HeaderNew";


const SubHeader = () => {
    return (
        <div className="header-bottom-wrapper ">
            <div className="menu reveal  fade-left">
                <ul>
                    <li><a href="/">{t(HOME)}</a></li>
                    <li><a href="/booking-enquiry">{t(BE)}</a></li>
                    {
                        window.customerProfile.isLoggedIn ?
                            <li><a href="/account?cancel=true">{t(CT)}</a></li>
                            :
                            <li><a href="/guest-cancel">{t(CT)}</a></li>
                    }
                    {
                        <li><a href="/tour-guest-cancel">KSTDC Tour Cancel Ticket</a></li>
                    }
                    {/*
                    <li>
                        <a>{t(CT)}</a>
                        <ul className="drop-manage">
                            {
                                window.customerProfile.isLoggedIn ?
                                    <li><a href="/account?cancel=true">{t(CBT)}</a></li>
                                    :
                                    <li><a href="/guest-cancel">{t(CBT)}</a></li>
                            }
                        </ul>
                    </li>
                     {
                        window.customerProfile.isLoggedIn ?
                            <li><a href="/account">Edit Bus Booking</a></li>
                            :
                            <li><a href="/guest-edit">Edit Bus Booking</a></li>
                    } 
                    <li><a href="/">{t(PT)}</a></li>*/}
                </ul>
            </div>
            <div className="social-media-links reveal fade-right">
                <span>
                {t(FU)}
                </span>
                <ul>
                    {window.facebook &&
                        <li>
                            <a  href={window.facebook} target="_blank">
                                {renderImg('ic_fb.svg')}
                            </a>
                        </li>
                    }
                    {window.twitter &&
                        <li>
                            <a  href={window.twitter} target="_blank" >
                                {renderImg('ic_twitter.svg')}
                            </a>
                        </li>
                    }


                    {window.instagram &&
                        <li>
                            <a  href={window.instagram} target="_blank">
                                {renderImg('ic_instagram.svg')}
                            </a>
                        </li>
                    }
                    {
                        window.linkdin &&
                        <li>
                            <a  href={window.linkdin} target="_blank">
                                {renderImg('ic_linkedin.svg')}
                            </a>
                        </li>
                    }

                    {window.googlePlus &&
                        <li>
                            <a  href={window.googlePlus} target="_blank">
                                {renderImg('ic_google_plus.svg')}
                            </a>
                        </li>
                    }

                    {
                        window.youtube &&
                        <li>
                            <a  href={window.youtube} target="_blank">
                                {renderImg('ic_youtube.svg')}
                            </a>
                        </li>
                    }

                </ul>
            </div>
        </div>
    )
}
export default SubHeader;